export const ControlItemsPanel = ({ m }) => {
  const rows = m?.controls || [];

  return (
    <div data-testid="admin-control-items-panel">
      <p className="label">Every control item fired, and how it scored</p>
      <table className="mt-6 w-full text-left">
        <thead>
          <tr className="border-b border-[var(--line)]">
            {["Item", "Type", "Pairs", "Result", "Score", "Note"].map((h) => (
              <th key={h} className="label py-2 pr-4">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((c) => (
            <tr key={c.item_id} className="border-b border-[var(--line)] align-top">
              <td className="py-3 pr-4 font-data text-[11px] text-zinc-300">{c.item_id}</td>
              <td className="py-3 pr-4 font-data text-[11px] text-zinc-400">{c.type}</td>
              <td className="py-3 pr-4 font-data text-[11px] text-zinc-600">{c.pairs_with || "—"}</td>
              <td className="py-3 pr-4 font-data text-[11px] text-zinc-100">{c.result}</td>
              <td className="py-3 pr-4 font-data text-[11px] tabular-nums text-zinc-300">
                {c.turn_score}
              </td>
              <td className="py-3 pr-4 text-xs text-zinc-500">{c.note}</td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr>
              <td colSpan={6} className="py-6 font-data text-[11px] text-zinc-600">
                No control items fired yet.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ControlItemsPanel;
